import styled from '@emotion/styled/macro';
import { Link } from 'react-router-dom';

export const Button = styled.button`
    border-style: solid;
    border-width: 1px;
    border-color: ${props =>
        props.type === 'default'
            ? props.theme.componentColours.button.default.border
            : props.theme.componentColours.button.secondary.border};
    border-radius: 2px;
    background-color: ${props =>
        props.type === 'default'
            ? props.theme.componentColours.button.default.background
            : props.theme.componentColours.button.secondary.background};
    position: relative;
    overflow: hidden;
    width: 100%;
    margin: auto;
    height: 100%;

    :after {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 50%;
        transform: skewX(-76deg);
        background: rgba(0, 0, 0, 0.1);
        z-index: 1;
    }

    &::after {
        transition: transform 0.2s ease-in-out, left 0.2s ease-in-out;
    }

    &:hover {
        &::after {
            transform: skew(-70deg);
            left: 40%;
        }
    }
`;

export const ButtonText = styled.div`
    font-size: ${props => props.theme.fontSize.medium};
    color: ${props => props.theme.colours.textWhite};
    font-weight: bold;
    z-index: 2;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ButtonLink = styled(Link)`
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    position: relative;
    width: 90%;
    margin: 10px auto;
    padding: ${props => props.theme.spacing.medium};
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: ${props => props.theme.fontWeight.medium};
    color: ${props => props.theme.colours.textWhite};

    &:disabled {
        opacity: 0.5;

        &:disabled {
            cursor: not-allowed;
        }
    }
`;
